import { ajax } from 'rxjs/ajax'
import { retry } from 'rxjs/operators'
import envGet from 'Support/Env/Get/EnvGet.support'
import { ServiceHeadersContentTypeJson } from 'Constants/Service/json-headers'

const BASE_URL_FLITCH = envGet({ key: `REACT_APP_BORAL_BASE_URL_FLITCH` }) as string
const SUBMIT_PLUS_LOAD_URL = envGet({ key: `REACT_APP_BORAL_SUBMIT_PLUS_LOAD_URL` }) as string

interface Options {
  authHeaders?: any,
  quantity: number,
  orderKey: string,
}

const submitPlusLoadService = async (options: Options) => {
  const {
    authHeaders = {},
    quantity,
    orderKey,
  } = options
  const headers = {
    ...authHeaders,
    ...ServiceHeadersContentTypeJson,
  }
  const payload = {
    quantity,
    orderKey,
  }
  const body = payload
  const url = `${BASE_URL_FLITCH}${SUBMIT_PLUS_LOAD_URL}`

  return ajax({
    body,
    headers,
    method: `PUT`,
    url,
  })
    .pipe(retry(1))
    .toPromise()
}

export default submitPlusLoadService
